import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Grid} from "@mui/material";
import CustomButton from "../../../../components/CustomButton";
import valid from "assets/img/validIcon.svg"
import cross from "assets/img/CrossIcon.svg"

ValidButtons.propTypes = {
    handleIsValid: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
};

function ValidButtons({handleIsValid, item}) {
    const [isLoading, setIsLoading] = useState(false)
    const handleClick = (isValid, item) => {
        if (isValid) {
            setIsLoading(true)
        }

        handleIsValid(isValid, item)
    }

    return (
        <Grid container flexWrap={"nowrap"} gap={"8px"} justifyContent={"center"}>
            <CustomButton
                color={"red"}
                onClick={() => handleClick(false, item)}
                rounded
                disabled={isLoading}
            >
                <img
                    src={cross}
                    alt={"cross-icon"}
                />
            </CustomButton>
            <CustomButton
                onClick={() => handleClick(true, item)}
                rounded
                disabled={isLoading}
                loading={isLoading}
            >
                <img
                    src={valid}
                    alt={"valid-icon"}/>
            </CustomButton>
        </Grid>
    );
}

export default ValidButtons;